import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import { MenuItem, MenuItemType } from '../../../../typings/menu';
import LeftMenuItem from '../../../../components/MenuManager/Left/MenuItem';
import Utils from '../../../../utils';
import DriveItemUtils from '../../../../utils/driveItem';

interface MenuItemOwnProps {
	menuItem: MenuItem;
	badge?: number;
}

enum LocationPathName {
	Folder = '/list/folder',
	Page = '/page',
	Search = '/list/search'
}

const mapStateToProps = (state: StoreState, ownProps: MenuItemOwnProps) => {
	const {
		appInfos,
		routing,
		search,
		galleryInfos: { config },
		routerParamsHistory,
		driveList,
	} = state;
	const { menuItem } = ownProps;
	const { type, target} = menuItem;
	const { isShown, searchString } = search;
	const { driveItems } = driveList;
	const isRoute = Utils.isMenuItemTypeRoute(menuItem.type);
	const isMultiApp = Utils.isMultiApp(appInfos);

	const isItemActive = () => {
		if (menuItem) {
			const targetId = Utils.getMediaId(target);

			if (type === MenuItemType.Folder) {
				return routing.locationBeforeTransitions.pathname === `${LocationPathName.Folder}/${targetId}`;
			} else if (type === MenuItemType.Page) {
				return routing.locationBeforeTransitions.pathname === `${LocationPathName.Page}/${targetId}`;
			} else if (type === MenuItemType.SearchButton) {
				return isShown || routing.locationBeforeTransitions.pathname === `${LocationPathName.Search}/${searchString}`;
			} else if (type === MenuItemType.Documents) {
				const currentFolderId = Utils.getCurrentFolderId(config.applicationGallery, routerParamsHistory);
				const privateDirId = Utils.getPrivateDirId(driveList, config);
				return routing.locationBeforeTransitions.pathname.includes(LocationPathName.Folder) && DriveItemUtils.isPrivateDirDescendant(currentFolderId, privateDirId, driveItems);
			} else if (isRoute) {
				return routing.locationBeforeTransitions.pathname === `/${target}`;
			}
		}

		return false;
	};

	return {
		isActive: isItemActive(),
		isRoute,
		isMultiApp
	};
};

export default connect(mapStateToProps)(LeftMenuItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/MenuItem/index.tsx